import * as React from "react";
import { useEffect, useRef } from "react";
import { Link, Routes, Route, useNavigate, Navigate, Outlet } from "react-router-dom";

import { TabList, Tab, Button, Icon } from "@vibe/core";

import { Info, Alert } from "@vibe/icons";

//import { Accordion, AccordionItem } from "monday-ui-react-core";

//import { useAuth, default as AuthConsumer } from "./auth/useAuth.jsx";
//import useAuth from "./auth/useAuth.jsx";
import AuthConsumer from "./auth/useAuth.jsx";
import RequireAuth from "./auth/requireauth.jsx";
import Loader from "./libs/loader.jsx";
import Monday from "./auth/useMonday.jsx";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

//import Dashboard from "./dashboard.jsx";

import DatasetList from './dataset/list.jsx';
import DatasetEdit from "./dataset/edit.jsx";

import Settings from "./settings/settings.jsx";
import Documentation from "./documentation/documentation.jsx";

import BackgroundCache from "./libs/backgroundCache.jsx";

const E404 = () => (
    <div className="container-fluid">
        <h1>404</h1>
    </div>
);

import DataRelations from "./dataRelations/dataRelations.jsx";

import DatasetHistory from "./datasetHistory/list.jsx";

import Login from "./auth/login.jsx";


function openPlans()
{
    monday.execute('openPlanSelection', {isInPlanSelection: true});
}

function openBills()
{
    monday.execute('openPlanSelection', {isInPlanSelection: false});
}


function Subscription()
{
    const [imgLogo, setImgLogo] = React.useState("logo.png");
    const [accountId, setAccountId] = React.useState(null);
    
    let loader = React.createRef();
    
    const onThemeChanged = (theme) => {
        //console.log('main onThemeChanged', theme);
        var logo = "";
        switch(theme)
        {
            case 'light': logo = 'logo.png'; break;
            default:
                logo = 'logo-dark.png';
            break;
        }
        setImgLogo(logo);
    }
    
    const themeListener = () => {
        monday.listen(['context'], function(data) {
            if( (`data` in data) && (`theme` in data['data']))
            {
                onThemeChanged(data['data']['theme']);
            }
        });
    }
    
    const getAccountId = async function()
    {
        let account_id = await Monday.getMondayAccountId(loader);
        //console.log('Subscription getAccountId', account_id);
        
        if(account_id)
        {
            setAccountId(account_id);
        }
    }
    
    useEffect(() => {
        getAccountId();
    }, [])
    
    return (
        <Loader ref={loader}>
            <div className="container-fluid" style={{'color':'var(--primary-text-color)'}}>

                <nav className="navbar navbar-expand-xl navbar-light bg-transparent">
                    <div className="navbar-brand" href="#">
                        <img src={ '/img/' + imgLogo } width="30" height="30" className="d-inline-block align-top" style={{'marginTop': '3px'}} alt="{config.texts.name}" />
                        <span className="navbar-brand mb-0 h1 titleFont" style={{ 'color': 'var(--primary-text-color)' }}>{config.texts.name}</span>
                    </div>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </nav>

                <h1>Subscription</h1>

                <p>Your app license does not match your monday.com user tier.</p>
                <p>Please upgrade your license or contact your monday.com instance administrator.</p>

                <Button onClick={(e) => monday.execute('openPlanSelection', {isInPlanSelection: false}) } type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.SMALL} leftIcon={Info}>Open Billing</Button>
                
                <div className="form-group form-row mb-2 mt-5 mr-1 d-flex justify-content-end">
                    <div className="col-1 col-sm-1 col-md-1 mb-2 text-right">
                        Account ID:
                    </div>
                    <div className="col-1 col-sm-1 col-md-1 mb-2">
                        {accountId}
                    </div>
                </div>
            </div>
        </Loader>
    );
}

//<Link to="/asdqwdw">404</Link> | <Link to="/">dataset</Link> | <Link to="/token">token</Link> | <Link to="/login">login</Link>
//<br />
//<Button onClick={(e) => openPlans()} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.SMALL}>Open Plans</Button>
//<Button onClick={(e) => openBills()} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.SMALL}>Open Bills</Button>

//create your forceUpdate hook
function useForceUpdate(){
    const [value, setValue] = React.useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
    // An function that increment 👆🏻 the previous state like here 
    // is better than directly setting `value + 1`
}

function Menu(props)
{
    const auth = AuthConsumer();
    const navigate = useNavigate();
    
    const forceUpdate = useForceUpdate();
    
    const [activeTab, setActiveTab] = React.useState({
        'index': true,
        'settings': false,
        'data_relations': false,
        'dataset_history': false,
        'documentation': false,
    });
    
    var external = {
        'support_request': config.texts.url_mainmenu_supportrequest,
        'documentation': config.texts.url_mainmenu_documentation,
    };
    
    const openInNewTab = url => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    
    const activateTab = target => {
        target = target || 'index';
        
        if( activeTab[target] == true) return;
        
        for(var i in activeTab)
        {
            if(target in external) continue;
            
            if(i==target)
                activeTab[i]=true;
            else
                activeTab[i]=false;
        }
        setActiveTab({...activeTab}); //workaround forceUpdate();
    };
    
    const onTabClick = (target, ...args) => {
        
        activateTab(target);
        
        if(target in external)
        {
            openInNewTab(external[target]);
        }
        else
        {
            switch(target)
            {
                case 'settings': navigate("/settings"); break;
                case 'data_relations': navigate("/data_relations"); break;
                case 'dataset_history': navigate("/dataset_history"); break;
                
                //case 'documentation': navigate("/documentation"); break;
                default: navigate("/"); break;
            }
        }
        
        $(".navbar-collapse").collapse("hide");
        //forceUpdate();
    };
    
    props.childRef.current = {
        'activateTab': activateTab,
        'onTabClick': onTabClick
    };
    
    return (
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div className="navbar-nav">
                <Tab className="nav-item text-nowrap" onClick={() => onTabClick('index')} active={activeTab['index']}>Data Sources</Tab>
                <Tab className="nav-item text-nowrap" onClick={() => onTabClick('settings')} active={activeTab['settings']}>{((auth.personalToken!=='' && auth.personalTokenValid==false) || auth.tracketTokenValid===false)?<Icon icon={Alert} style={{'color': "var(--color-error)", 'verticalAlign': 'sub'}} iconSize="19" />:null}Settings</Tab>
                <Tab className="nav-item text-nowrap" onClick={() => onTabClick('data_relations')} active={activeTab['data_relations']}>Data Relationships</Tab>
                <Tab className="nav-item text-nowrap" onClick={() => onTabClick('dataset_history')} active={activeTab['dataset_history']}>Data Source History</Tab>
                <Tab className="nav-item text-nowrap" onClick={() => onTabClick('support_request')} active={false}>Support Request</Tab>
                <Tab className="nav-item text-nowrap" onClick={() => onTabClick('documentation')} active={false}>Documentation</Tab>
            </div>
        </div>
    );
}



export default function Main()
{
    const [imgLogo, setImgLogo] = React.useState("logo.png");
    
    let menu_instance_ref = useRef(null);
    var menu_instance = Menu({'childRef': menu_instance_ref});
    
    return (
        <div className="container-fluid" style={{ 'display': 'flex', 'height': '100%', 'flexFlow': 'column', 'color':'var(--primary-text-color)'}}>
            
            {
                ( (window.self !== window.top) ) ?
                    
                <Routes>
                    <Route path="/" element={
                        <RequireAuth>
                            <nav className="navbar navbar-expand-xl navbar-light bg-transparent">
                                <div className="navbar-brand navbar-brand-link" href="#" onClick={() => menu_instance_ref.current.onTabClick('index')}>
                                    <img src={ '/img/' + imgLogo } width="30" height="30" className="d-inline-block align-top" style={ {'marginTop': '3px', 'marginRight': '8px'} } alt={ config.texts.name } />
                                    <span className="navbar-brand mb-0 h1" style={{ 'color': 'var(--primary-text-color)' }}>{config.texts.name}</span>
                                </div>
                                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                { menu_instance }
                            </nav>
                            <Outlet />
                        </RequireAuth>
                    }>
                        <Route path="/">
                            <Route index element={
                                <DatasetList />
                             } />
                            <Route path="add" element={
                                <DatasetEdit />
                             } />
                            <Route path="edit/:id" element={
                                <DatasetEdit />
                             } />
                        </Route>
                        
                        <Route path="/settings/*" element={<Settings />} />

                        <Route path="/data_relations" element={<DataRelations />} />
                        <Route path="/dataset_history" element={<DatasetHistory />} />
                        <Route path="/documentation" element={<Documentation menu={ menu_instance_ref.current } />} />
                    </Route>

                    <Route path="/login" element={<Login />} />
                    <Route path="/subscription" element={<Subscription />} />
                    <Route path="*" element={<E404 />} />
                </Routes>
                :
                <div>Access denied</div>
            }
            
        </div>
    );
}

//<Route exact path="/details/:id" render={(props) => <DetailsPage globalStore={globalStore} {...props} /> } />

